import { z } from "zod"

export const missionFileRecordSchema = z.object({
    id: z.string(),
    org_id: z.string(),
    mission_id: z.string(),
    name: z.string().min(1).max(255),
    expires_at: z.string().nullable(),
    notes: z.string().max(2000).nullable(),
    file_name: z.string().max(500),
    file_size_bytes: z.coerce.number().nullable(),
    created_by: z.string(),
    created_at: z.date(),
    updated_at: z.date().nullable(),
})

export const missionFileSchema = missionFileRecordSchema.transform((r) => ({
    id: r.id,
    orgId: r.org_id,
    missionId: r.mission_id,
    name: r.name,
    expiresAt: r.expires_at,
    notes: r.notes,
    fileName: r.file_name,
    fileSizeBytes: r.file_size_bytes,
    createdBy: r.created_by,
    createdAt: r.created_at.toISOString(),
    updatedAt: r.updated_at?.toISOString() ?? null,
}))

export const creatableMissionFileSchema = missionFileRecordSchema.omit({
    created_at: true,
    updated_at: true,
    org_id: true,
    mission_id: true,
    created_by: true,
})

export type MissionFileRecord = z.infer<typeof missionFileRecordSchema>
export type MissionFile = z.infer<typeof missionFileSchema>
export type CreatableMissionFile = z.infer<typeof creatableMissionFileSchema>
